module.exports = __webpack_public_path__ + "img/arctic-circle-logo.36eafb0f.svg";